import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";

export const ModelosAgrupados = ({ modelos, seleccionados, onChange, testPrefix = "modelo", emptyMsg }) => {
  const [grupos, setGrupos] = useState([]);
  useEffect(() => { api.get("/grupos-cilindrada").then((r) => setGrupos(r.data)).catch(() => {}); }, []);

  const bloques = [
    ...grupos.map((g) => ({ id: g.id, nombre: g.nombre, modelos: modelos.filter((m) => m.grupo_cilindrada_id === g.id) })),
    { id: "sin-grupo", nombre: "Sin grupo", modelos: modelos.filter((m) => !m.grupo_cilindrada_id || !grupos.some((g) => g.id === m.grupo_cilindrada_id)) },
  ].filter((b) => b.modelos.length > 0);

  const toggleModelo = (id) =>
    onChange(seleccionados.includes(id) ? seleccionados.filter((x) => x !== id) : [...seleccionados, id]);

  const toggleGrupo = (b) => {
    const ids = b.modelos.map((m) => m.id);
    const todos = ids.every((id) => seleccionados.includes(id));
    onChange(todos ? seleccionados.filter((x) => !ids.includes(x)) : [...new Set([...seleccionados, ...ids])]);
  };

  const estadoGrupo = (b) => {
    const sel = b.modelos.filter((m) => seleccionados.includes(m.id)).length;
    return sel === 0 ? false : sel === b.modelos.length ? true : "indeterminate";
  };

  return (
    <div data-testid={`${testPrefix}s-agrupados`} className="border border-border rounded-sm p-2 max-h-44 overflow-y-auto overscroll-contain space-y-2">
      {modelos.length === 0 && <p className="text-xs text-muted-foreground">{emptyMsg || "No hay modelos registrados."}</p>}
      {bloques.map((b) => (
        <div key={b.id}>
          <label className="flex items-center gap-2 text-xs font-semibold text-slate-600 uppercase cursor-pointer bg-slate-50 rounded px-1.5 py-1">
            <Checkbox data-testid={`${testPrefix}-grupo-check-${b.id}`} checked={estadoGrupo(b)}
              onCheckedChange={() => toggleGrupo(b)} />
            {b.nombre}
            <span className="font-normal normal-case text-slate-400">— seleccionar todos ({b.modelos.length})</span>
          </label>
          <div className="grid grid-cols-2 gap-1 mt-1 pl-1.5">
            {b.modelos.map((m) => (
              <label key={m.id} title={m.nombre_mostrar || `${m.marca} ${m.modelo}`}
                className="flex items-start gap-2 text-sm cursor-pointer">
                <Checkbox data-testid={`${testPrefix}-check-${m.id}`} className="mt-0.5 shrink-0"
                  checked={seleccionados.includes(m.id)} onCheckedChange={() => toggleModelo(m.id)} />
                <span className="break-words leading-snug min-w-0">{m.nombre_mostrar || `${m.marca} ${m.modelo}`}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
